import { Stack, styled } from '@mui/material';

export const ConfirmChoiceAlerContainerStyled = styled(Stack)(({ theme }) => ({
  backgroundColor: theme.palette.semantic.warning[100],
  borderRadius: '0.625rem',
  border: `1px solid ${theme.palette.semantic.warning[500]}`,
  marginBottom: '1.5rem',
  padding: '0.5rem',
}));
